import { SVGProps, Ref, forwardRef } from 'react';

export const PhoneDownFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M10.79 8.994c-.115-.299-.34-.536-.639-.614-.426-.111-1.148-.244-2.162-.244-1.009 0-1.73.132-2.156.243-.303.079-.53.32-.643.624l-.67 1.79-3.77.707c-2.606-4.877 2.006-6.999 7.24-7 5.233-.001 9.872 2.119 7.26 6.997l-3.77-.706z"
                fill="currentColor"
            />
        </g>
    </svg>
));
PhoneDownFilledSize16Glyph.displayName = 'PhoneDownFilledSize16Glyph';
